<div [class.ghost]="fetchingTaskData">
  <div class="">
    <div class="">
      <job-screen-location
        [location]="pickupLocation"
        [task]="task"
        [earliestTime]="pickupEarliestDateTime"
        [latestTime]="pickupLatestDateTime"
        [originalEarliestDateTime]="originalPickupEarliestDateTime"
        [originalLatestDateTime]="originalPickupLatestDateTime"
        [IsPickup]="true"
      >
      </job-screen-location>
      <job-screen-location
        [location]="dropoffLocation"
        [task]="task"
        [earliestTime]="dropoffEarliestDateTime"
        [latestTime]="dropoffLatestDateTime"
        [originalEarliestDateTime]="originalDropoffEarliestDateTime"
        [originalLatestDateTime]="originalDropoffLatestDateTime"
        [IsPickup]="false"
      >
      </job-screen-location>
    </div>
  </div>
</div>
